import { Injectable } from '@angular/core';
import { EncryptStorageService } from '../encrypt-storage/encrypt-storage.service';

@Injectable({
  providedIn: 'root'
})
export class SessionStorageService {
  
  constructor(private encryptStorageService: EncryptStorageService) { }
  // Set the json data to local storage
  setValue(key: string, value: any) {
      this.encryptStorageService.secureSStorage.setItem(key, value);
  }
  // Get the json value from local storage
  getValue(key: string) {
      return this.encryptStorageService.secureSStorage.getItem(key);
  }
  // Clear the local storage
  clear() {
      return this.encryptStorageService.secureSStorage.clear();
  }
  // Remove a specific key-value pair from local storage
  removeValue(key: string) {
    return this.encryptStorageService.secureSStorage.removeItem(key);
  }
}
